import React, { Component } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../translations';

class Breadcrumb extends Component{
    static contextType = LanguageContext;

    render(){
        const { title , parent, translationKey} = this.props;
        const lang = this.context.language;

        // Use translation if translationKey is provided, otherwise use title prop
        const displayTitle = translationKey
            ? translations[lang][translationKey].breadcrumb.title
            : title;

        const homeText = translationKey
            ? translations[lang][translationKey].breadcrumb.home
            : 'Home';

        return(
            <React.Fragment>
                <div className="breadcrumb-area rn-bg-color ptb--120 bg_image bg_image--1" data-black-overlay="6">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="breadcrumb-inner pt--100">
                                    <h2 className="title">{displayTitle}</h2>
                                    <ul className="page-list">
                                        <li className="breadcrumb-item"><Link to={`${process.env.PUBLIC_URL}`}>{homeText}</Link></li>
                                        {parent? <li className="breadcrumb-item">{parent}</li>:''}
                                        <li className="breadcrumb-item active">{displayTitle}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Breadcrumb;

